<div class="layout-footer">
    <span class="font-medium ml-2 text-white">VV CAR 2023</span>
</div>
